import { validateEmail, validatePhone, validateString } from 'avilatek-utils';
import { Company } from '../../models';

export function validateCompanyForm({
  name,
  phone,
  dni,
  email,
}: Partial<Company>): string {
  if (!validateString(name) || String(name).length > 127) {
    return 'Nombre de la empresa es inválido';
  }

  if (!email || !validateEmail(email)) {
    return 'El correo electrónico de la empresa es inválido';
  }

  if (!validatePhone(phone) || String(phone).length > 12) {
    return 'El teléfono de la empresa es inválido';
  }

  if (String(dni).length !== 9) {
    return 'El número de identificación de la empresa es inválido, debe de tener 9 caracteres';
  }

  return '';
}
